var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",style:({
    'background-color':
      _vm.$route.name == 'Uc'
        ? '#F4F0E8'
        : _vm.$route.name == 'bookDetail'
        ? '#eff2f5'
        : '#F4F0E8',
  })},[_c('p',{staticClass:"tuijian"},[_vm._v("（推荐使用Chrome/edge浏览器）")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaae4364","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 